import { defineMessages } from 'react-intl';

export default defineMessages({
  auditTrail: {
    id: 'sentinel.components.auditTrailPanel.auditTrail',
    defaultMessage: 'Audit Trail',
  },
  description: {
    id: 'sentinel.components.auditTrailPanel.description',
    defaultMessage: 'Description',
  },
  comment: {
    id: 'sentinel.components.auditTrailPanel.comment',
    defaultMessage: 'Comment',
  },
  reason: {
    id: 'sentinel.components.auditTrailPanel.reason',
    defaultMessage: 'Reason',
  },
  timeStamp: {
    id: 'sentinel.components.auditTrailPanel.date',
    defaultMessage: 'Date',
  },
  userName: {
    id: 'sentinel.components.auditTrailPanel.actor',
    defaultMessage: 'Actor',
  },
  eventType: {
    id: 'sentinel.components.auditTrailPanel.eventType',
    defaultMessage: 'Action',
  },
});



// WEBPACK FOOTER //
// ./src/components/AuditTrailPanel/messages.js